import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from './Button';
import * as helpers from '../support/Helpers';
// FIXME: we need our own checkbox component
// import { Checkbox } from 'antd';
import './DefaultSettingsManager.css';

DefaultSettingsManager.propTypes = {
  className:   PropTypes.string,
  tool:        PropTypes.object,
  componentID: PropTypes.string,
  toolOptions: PropTypes.object,
  resetFunc:   PropTypes.func,
  testFunc:    PropTypes.func,
  showDot:     PropTypes.bool,
  // resetActive: PropTypes.bool,
  // storageKey:  PropTypes.string,
}

DefaultSettingsManager.defaultProps = {
  showDot: false
}

// Testing with FileInput
// This should be used in the resetActive function
// This check array equality becuase of the New Project settings (feature names, types and qualifiers)
DefaultSettingsManager.settingsAreNotDefault = function(tool, componentID, settings) {
    const inputs = tool.inputsForTarget(componentID);
    // const options = {};
    let isActive = false;
    for (const input of inputs) {
      if (!input.autoSave) { continue; }
      if (Array.isArray(input.default) && Array.isArray(settings[input.id])) {
        if (!helpers.arraysEqual(settings[input.id], input.default)) {
          // options[input.id] = settings[input.id];
          isActive = true;
        }
      } else if (input.type === 'selectLegend') {
        // console.log('selectLegend', settings[input.id], input.default);
        if (input.default && settings[input.id]?.['cgvID'] !== input.default) {
          // options[input.id] = settings[input.id];
          isActive = true;
        } else if (input.default === 'NEW' && input.defaultNewItemName && settings[input.id]?.['name'] !== input.defaultNewItemName) {
          // options[input.id] = settings[input.id];
          isActive = true;
        }
      } else if (input.type === 'inExcludeSelect') {
        if (input.defaultMode && settings[input.id]?.['mode'] !== input.defaultMode) {
          // options[input.id] = settings[input.id];
          isActive = true;
        } else if (input.defaultItems && !helpers.arraysEqual(settings[input.id]?.['items'], input.defaultItems)) {
          // options[input.id] = settings[input.id];
          isActive = true;
        }
      } else if (settings[input.id] !== input.default) {
        // options[input.id] = settings[input.id];
        isActive = true;
      }
    }
    return isActive;
}

function DefaultSettingsManager(props) {
  const {
    className,
    tool,
    componentID,
    toolOptions,
    resetFunc,
    testFunc,
    showDot,
  } = props;

  // const storageKey = `dsm.${tool.id}.${componentID}`;

  function resetDefaults() {
    resetFunc && resetFunc();
  }

  // Returns true if any options are not the defualt value
  function resetActive() {
    return DefaultSettingsManager.settingsAreNotDefault(tool, componentID, toolOptions);
  }

  // function onChangeStatus(value) {
  //   // console.log('status', value);
  //   // console.log('key', storageKey);
  //   if (value && storageKey) {
  //     localStorage.setItem(storageKey, '{}');
  //   } else {
  //     localStorage.removeItem(storageKey);
  //   }
  //   // setStatusOn(value);
  // }

  const dsmClass = classNames(
    'DefaultSettingsManager', className
  );

  function inputsUseDefaultSettingsManager() {
    const inputs = tool.inputsForTarget(componentID);
    // console.log("INPUTS", inputs)
    // return inputs.some( input => input.defaultSettingsManager );
    return inputs.some( input => input.autoSave );
  }

  // function saveNewDefaultsToLocalStorage() {
  //     const inputs = tool.inputsForTarget(this.component.id);
  //     const options = {};
  //     for (const input of inputs) {
  //       if (input.defaultSettingsManager) {
  //         if (toolOptions[input.id] !== input.default) {
  //           options[input.id] = toolOptions[input.id];
  //         }
  //       }
  //     localStorage.setItem(storageKey, JSON.stringify(options));
  //   }
  // }

  if (!inputsUseDefaultSettingsManager()) { return null; }

  const testButton = testFunc && (
      <Button
        className='dms-btn-reset'
        height={32}
        width='50px'
        onClick={ testFunc }
        title='Test saving changes to LocalStorage'
      >Test</Button>
  );
  const width = (showDot && resetActive()) ? '114px' : '98px';
  return (
    <div className={dsmClass}>
      <Button
        className='dms-btn-reset'
        height={32}
        disabled={!resetActive()}
        width={width}
        onClick={ resetDefaults }
        title='Reset all settings to their default values'
      >
        <div className='dms-btn-contents'>{showDot && resetActive() && <div className='dms-btn-dot'></div>}<div>Reset Options</div></div>
      </Button>
      {testButton}
    </div>
  )
}

export default DefaultSettingsManager;

